<template>
  <page-outline :title="$t('Webheader.connector_list_'+entitiesType+'_'+role+'_'+type)">
    <template slot="pageContent">
      <b-container fluid class="listPage">
        <b-row class="justify-content-start">
          <b-col cols="4" sm="3" md="2" xl="1">
            <back-button :returnUrl="returnUrl"></back-button>
          </b-col>
          <b-col cols="4" sm="3" md="2" xl="1">
            <b-button class="btnFilter" :disabled="activateSpinner"
              @click="onRefresh()">
              <i class="fa-light fa-rotate-right fs-14px"></i>
              {{ $t('common.rfrsh') }}
            </b-button>
          </b-col>
        </b-row>

        <br />
        <b-tabs :value="role == 0 ? 1 : 0" nav-class="d-none">
          <!-- Credential LIST -->
          <b-tab :class="role == 0 ? 'd-none': ''" :title="$t('common.routing.receiver')">
            <b-row>
              <b-col md="12">
                <spinner v-if="activateSpinner"></spinner>
                <div v-else>
                  <b-table hover relative responsive
                           v-if="mqseriesCredentialFields.length"
                           class="mt-3 table-striped"
                           :items="mqseriesCredentialList"
                           :fields="mqseriesCredentialFields"
                           selectable select-mode="single" @row-selected="seeMQSeriesCredentialDetails">
                  </b-table>

                  <div v-else class="d-flex justify-content-center">
                        <span class="noResult">
                          {{ $t('common.no_result') }}
                        </span>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-tab>

          <b-tab :class="role == 1 ? 'd-none': ''" :title="$t('common.routing.responder')">
            <b-row>
              <b-col md="12">
                <spinner v-if="activateSpinner"></spinner>
                <div v-else>
                  <b-table hover relative responsive
                           v-if="mqseriesFields.length"
                           class="mt-3 table-striped table-hover"
                           :items="mqseriesConfigList"
                           :fields="mqseriesFields"
                           selectable select-mode="single" @row-selected="seeMQSeriesDetails">
                  </b-table>

                  <div v-else class="d-flex justify-content-center">
                        <span class="noResult">
                          {{ $t('common.no_result') }}
                        </span>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-tab>

        </b-tabs>
      </b-container>
    </template>
  </page-outline>

</template>

<script>

import Spinner from '@/components/common/spinner.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import BackButton from '@/components/common/backButton.vue'
import PageOutline from '@/components/common/PageOutline.vue'

export default {
  name: 'MQSeriesList',
  components: {
    PageOutline,
    BackButton,
    'spinner': Spinner
  },
  props: {
    entitiesType: {
      default: 'rvm'
    },
    id: {
      default: 'null'
    },
    role: {
      default: 'null'
    },
  },
  computed: {
    mqseriesFields () {
      return [
        { key: 'Name', label: this.$t('common.routing.config_name'), class: 'text-center' },
        { key: 'FormatName', label: this.$t('common.routing.format_name'), class: 'text-center' },
        { key: 'Host', label: this.$t('common.routing.host'), class: 'text-center' },
        { key: 'Port', label: this.$t('common.routing.port'), class: 'text-center' },
        { key: 'SSLActive', label: this.$t('common.routing.ssl_active'), class: 'text-center' },
        { key: 'ConnectionMode', label: this.$t('common.routing.connection_mode'), class: 'text-center' },
        { key: 'ConnectionType', label: this.$t('common.routing.connection_type'), class: 'text-center' },
        { key: 'QueueManager', label: this.$t('common.routing.queue_manager'), class: 'text-center' },
        { key: 'ChannelName', label: this.$t('common.routing.channel_name'), class: 'text-center' },
        { key: 'QueueName', label: this.$t('common.routing.queue_name'), class: 'text-center' }
      ]
    },
    mqseriesCredentialFields () {
      return [
        { key: 'Name', label: this.$t('common.routing.config_name'), class: 'text-center' },
        { key: 'FormatName', label: this.$t('common.routing.format_name'), class: 'text-center' },
        { key: 'Host', label: this.$t('common.routing.host'), class: 'text-center' },
        { key: 'Port', label: this.$t('common.routing.port'), class: 'text-center' },
        { key: 'SSLActive', label: this.$t('common.routing.ssl_active'), class: 'text-center' },
        { key: 'TimeOut', label: this.$t('common.routing.timeout'), class: 'text-center' },
        // { key: 'ConnectionMode', label: this.$t('common.routing.connection_mode'), class: 'text-center' },
        // { key: 'ConnectionType', label: this.$t('common.routing.connection_type'), class: 'text-center' },
        { key: 'QueueManager', label: this.$t('common.routing.queue_manager'), class: 'text-center' },
        { key: 'ChannelName', label: this.$t('common.routing.channel_name'), class: 'text-center' },
        { key: 'QueueName', label: this.$t('common.routing.queue_name'), class: 'text-center' }
      ]
    },
  },
  data () {
    return {
      activateSpinner: false,
      interProcessConfigList: [],
      mqseriesConfigList: [],
      mqseriesCredentialList: [],
      FTPConfigList: [],
      FTPCredentialList: [],
      pageCounter: 0,
      returnUrl: '',
      entityType: 0,
      remoteFolderConfigList: [],
      tabName: 1,
      tabIndex: 0,
      type: 0,
      webServiceConfigList: [],
      webServiceCredentialList: [],
    }
  },
  created () {
    if (this.entitiesType == 'requester'){
      this.entityType = '0'
      this.returnUrl = '/routing/configlist/1/0/' + this.entitiesType
    }
    if (this.entitiesType == 'responder'){
      this.type = 1
      this.entityType = '2'
      this.returnUrl = '/routing/configlist/0/1/' + this.entitiesType
    }
    if (this.entitiesType == 'rvm'){
      this.entityType = '1'
      this.returnUrl = '/routing/configlist/'+ this.role + '/0/' + this.entitiesType
    }
    this.onRefresh()
  },
  mounted () {
  },
  beforeDestroy () {
  },
  watch: {
    role(newValue) {
      this.tabName = newValue == '1' ? 1 : 0
    },
  },
  methods: {
    getConfigMQSeries () {
      let that = this
      this.$engine.routing.config.mqseries.fetch({
        entityType: this.entityType,
        Role: this.role,
        IdConfigRouting: this.id
      })
      .then(resp => {
        let mqseriesList = {}

        mqseriesList = resp.data.MQSeriesConfig
        this.mqseriesConfigList = mqseriesList
        this.mqseriesConfigList.forEach(mqseries=> {
          if (mqseries.SSL === '1') {
            mqseries.SSLActive = this.$t('common.routing.yes')
          } else {
            mqseries.SSLActive = this.$t('common.routing.no')
          }
        })

        mqseriesList = {}

        mqseriesList = resp.data.MQSeriesCredential
        this.mqseriesCredentialList = mqseriesList
        this.mqseriesCredentialList.forEach(mqseries=> {
          if (mqseries.SSL === '1') {
            mqseries.SSLActive = this.$t('common.routing.yes')
          } else {
            mqseries.SSLActive = this.$t('common.routing.no')
          }
        })
        this.activateSpinner = false

        this.$f7.pullToRefreshDone()
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    onRefresh (index = 1) {
      this.activateSpinner = true
      this.pageCounter = 0

      // this.getConfigInterProcess()
      this.getConfigMQSeries()
      // this.getConfigRemoteFolder()

      this.$f7.pullToRefreshDone()
    },
    seeMQSeriesDetails (items) {
      let config = items[0]
      let that = this

      this.$engine.routing.config.clickedConfig = config
      loadPage(that, {url: '/routing/mqseriesConfigurationDetails/details/' + this.entitiesType + '/' + this.role + '/' + this.id})
    },
    seeMQSeriesCredentialDetails (items) {
      let config = items[0]
      let that = this

      this.$engine.routing.config.clickedConfig = config
      loadPage(that, {url: '/routing/mqseriesCredentialDetails/details/' + this.entitiesType + '/' + this.role + '/' + this.id})
    }
  }
}
</script>
